<template>
    <div class="form-group" :class="wrapClasses">
        <select
            :name="selectName"
            :class="selectClasses"
            :disabled="disabled"
            :readonly="readonly"
            @change="$emit('change', $event.target.value)"
            :data-element="checkDataElement(dataElement ? dataElement : dataElementPrefix + 'select-' + name)"
        >
            <option
                v-for="(option, key) in options"
                :key="key"
                :value="option.value"
                :selected="value == option.value"
                :data-element="checkDataElement(dataElementPrefix + 'option-' + name + '-'+option.value)"
            >

                {{ option.title }}
            </option>
        </select>
    </div>
</template>

<script>
/* global Mango */
export default {
    name: "FieldSelect",
    model: {
        prop: 'value',
        event: 'change'
    },
    props: {
        name: {
          type: String,
          default: ''
        },
        options: Array,
        dataElement: String,
        dataElementPrefix: String,
        value: [String, Number],
        disabled: Boolean,
        readonly: Boolean,
        size: String,
        error: [String, Boolean]
    },
    computed: {
        selectName() {
          return this.name
        },
        wrapClasses() {
            let classes = [];

            if (this.error && !this.disabled) {
                classes.push('has-error');
            }

            if (this.value !== null && this.value !== undefined) {
                if (('' + this.value) !== '') {
                    classes.push('has-value');
                }
            }

            return classes
        },
        selectClasses() {
            let classes = [];

            if (this.size) {
                classes.push(this.size);
            }

            return classes
        }
    },
    mounted() {
        if (Array.isArray(this.options) && this.options.length > 0 && !this.value) {
            this.$emit('change', this.options[0].value)
        }
    },
    methods: {
        checkDataElement(id) {
            return Mango.checkDataElement(id);
        }
    }
}
</script>

<style scoped>

</style>